// React
import React, { useContext, useState } from "react";
// React
// CSS
import styles from "./LessonCard.module.css";
// CSS
// Models
import { I_SampleExamPdf } from "../../../../Models/interfaces";
// Models
// Modules
import * as Farvardin from "farvardin";
// Modules
// Services
// Services
// Context
import { UserTokenContext } from "../../../../Contexts/userToken";
// Context
// Components
import LessonCardModal from "./LessonCardModal/LessonCardModal";
// Components
// Icons
import { AiOutlineShoppingCart } from "react-icons/ai";
import { AiOutlineCalendar } from "react-icons/ai";
import { BsFillPlayCircleFill } from "react-icons/bs";
// Icons
import { useNavigate } from "react-router-dom";
import { pdf_icon } from "../../../../Images/images";
import { downloadPdf } from "../../../../Utils/downloader";

type LessonCardProps = {
  data: I_SampleExamPdf;
  teacherName: string;
  setPdfs: React.Dispatch<React.SetStateAction<I_SampleExamPdf[]>>;
};

const LessonCard: React.FunctionComponent<LessonCardProps> = ({
  data: { id, title, price, has_paid, can_download, download_url },
  teacherName,
  setPdfs,
}) => {
  const userToken = useContext(UserTokenContext);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  return (
    <div
      className={`${styles.lessonCard} w-full py-2 flex flex-row items-center justify-between pt-4 dark:!text-black`}
    >
      {isModalOpen ? (
        <LessonCardModal
          setIsModalOpen={setIsModalOpen}
          pdfItemId={id}
          userToken={userToken}
          isPaid={has_paid}
          productName={title}
          productPrice={price}
          setPdfs={setPdfs}
        />
      ) : null}
      <div
        className={`${styles.outer} flex flex-row items-center justify-center`}
      >
        {/* <FiMonitor className="p-2 ml-2 text-5xl" /> */}
        <img src={pdf_icon} alt="" className="w-14 ml-2" />
        <div
          className={`${styles.inner} flex flex-col items-start justify-between`}
        >
          <span className=" text-xs w-11/12">{title}</span>
          {/* <span className="min-w-max text-xs flex items-center flex-row-reverse">
            {((): React.ReactNode => {
              if (!opening_date) return "";
              const targetDate = opening_date.split("-");
              console.log(targetDate);
              const x = Farvardin.gregorianToSolar(
                Number(targetDate[0]),
                Number(targetDate[1]),
                Number(targetDate[2]),
                "string"
              );
              return (
                <>
                  {opening_date ? x : ""} <AiOutlineCalendar className="ml-2" />
                </>
              );
            })()}
          </span> */}
        </div>
      </div>
      <button
        className={`${styles.buyButton} p-1 px-4 rounded-xl text-sm text-white flex flex-row-reverse items-center justify-center no-wrap w-4/12 `}
        style={{ background: has_paid ? "rgb(83 , 109 , 254)" : "" }}
        onClick={async () => {
          if (!has_paid && !can_download) {
            setIsModalOpen(true);
            return;
          } else
            try {
              await downloadPdf(download_url.replace("http://easyno.ir/", "https://app.amoozeshmelli.com/dfiles/"), title + ".pdf");
            } catch (err) {
              alert("خطا در دانلود فایل:‌ " + err);
            }
        }}
      >
        {has_paid ? (
          <>
            دانلود
            <BsFillPlayCircleFill className="ml-1" />
          </>
        ) : (
          <>
            {price === 0 ? (
              "رایگان"
            ) : (
              <>
                <span>{Number(price).toLocaleString("fa-EG")}</span>
                <span className="" style={{ fontSize: `8px` }}>
                  تومان
                </span>
                <span>
                  <AiOutlineShoppingCart />
                </span>
              </>
            )}
          </>
        )}
      </button>
    </div>
  );
};

export default LessonCard;
